import { render, staticRenderFns } from "./ProductInstruction.vue?vue&type=template&id=5ce27f54&scoped=true&"
import script from "./ProductInstruction.vue?vue&type=script&lang=js&"
export * from "./ProductInstruction.vue?vue&type=script&lang=js&"
import style0 from "./ProductInstruction.vue?vue&type=style&index=0&id=5ce27f54&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce27f54",
  null
  
)

export default component.exports